import { useLayoutEffect, useState } from 'react';

const getAutoWidth = (widthArray: number[]) => {
    const widthResult = widthArray.reduce(
        (acc, width) => {
            const total = acc.total + (width || 0);
            const zeroWidthCount = acc.zeroWidthCount + (width ? 0 : 1);

            return { total, zeroWidthCount };
        },
        { total: 0, zeroWidthCount: 0 }
    );
    const { total, zeroWidthCount } = widthResult;

    return `calc((100% - ${total}px) / ${zeroWidthCount})`;
};

export const useWidthCalculator = (widthArray: number[]) => {
    const [calculatedWidth, setCalculatedWidth] = useState<Array<number | string>>(widthArray);
    useLayoutEffect(() => {
        const autoWidth = getAutoWidth(widthArray);
        setCalculatedWidth(widthArray.map(width => width || autoWidth));
    }, [widthArray]);

    return calculatedWidth;
};
